class Pagination {
  constructor(totalItems) {
      this._totalItems = totalItems;
      this._currentPage = 1;
      this._pageSize = 20; // 페이지당 항목 수
      this._totalPages = Math.ceil(totalItems / this._pageSize);
      this._pageCount = 5; // 한 번에 표시할 페이지 갯수
      this._hasNext = false;
      this._hasPrev = false;
      this._startPage = 1;
      this._endPage = 1;
      this.updatePagination();
  }

  static gen(totalItems) {
      return new Pagination(totalItems);
  }

  // Getter and Setter for totalItems
  setTotalItems(totalItems) {
      this._totalItems = totalItems;
      this.updatePagination();
  }

  getTotalItems() {
      return this._totalItems;
  }

  // Getter and Setter for currentPage
  setCurrentPage(currentPage) {
      this._currentPage = currentPage;
      this.updatePagination();
  }

  getCurrentPage() {
      return this._currentPage;
  }

  // Getter and Setter for pageSize
  setPageSize(pageSize) {
      this._pageSize = pageSize;
      this.updatePagination();
  }

  getPageSize() {
      return this._pageSize;
  }

  // Getter and Setter for pageCount
  setPageCount(pageCount) {
      this._pageCount = pageCount;
      this.updatePagination();
  }

  getPageCount() {
      return this._pageCount;
  }

  getTotalPages() {
    return this._totalPages;
  }

  updatePagination() {
      this._totalPages = Math.ceil(this._totalItems / this._pageSize);
      this._hasNext = this._currentPage < this._totalPages;
      this._hasPrev = this._currentPage > 1;
      this._startPage = Math.floor((this._currentPage - 1) / this._pageCount) * this._pageCount + 1;
      this._endPage = Math.min(this._startPage + this._pageCount - 1, this._totalPages);
  }

  nextPage() {
      if (this._hasNext) {
          this._currentPage++;
          this.updatePagination();
      }
  }

  prevPage() {
      if (this._hasPrev) {
          this._currentPage--;
          this.updatePagination();
      }
  }

  // 시작 인덱스 번호 계산
  getStartIndex() {
      return (this._currentPage - 1) * this._pageSize;
  }

  // 페이지 정보 가져오기
  getPageInfo() {
      return `Current Page: ${this._currentPage}, Total Pages: ${this._totalPages}, Has Next: ${this._hasNext}, Has Prev: ${this._hasPrev}, Start Page: ${this._startPage}, End Page: ${this._endPage}, Start Index: ${this.getStartIndex()}`;
  }
}
export default Pagination
